import {Component, Input} from "@angular/core";
import {WorkflowTargetInfoModel} from "./models/workflow-target-info.model";

@Component({
  selector: "workflow-no-access",
  templateUrl: "./workflow-no-access.template.pug",
})

export class WorkflowNoAccessComponent {
  @Input()
  public workflowTargetInfo: WorkflowTargetInfoModel;

  @Input()
  public completelyHidden: boolean = true;

  constructor() {
  }
}
